import { useCookies } from "react-cookie";
import { Navigate } from "react-router-dom";

interface Props {
  children: React.ReactNode;
}

const PublicRoute = ({ children }: Props) => {
  const [cookies] = useCookies(["apiKey"]);
  const isAuthenticated = !!cookies.apiKey;

  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <>{children}</>;
};

export default PublicRoute;
